import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { MinutasPronosticoInterface, MinutasPronosticoService } from '@/domain/services/MinutasPronosticoService'
import { MinutasPronosticoState, StoreError } from './types'

const minutasPronostico: MinutasPronosticoInterface = new MinutasPronosticoService()

export const actions: ActionTree<MinutasPronosticoState, RootState> = {
  async getMinutasPronostico ({ commit }) {
    try {
      const actionResponse = await minutasPronostico.getMinutasPronostico()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getLinkDescarga ({ commit }, { fecha }): Promise<any> {
    try {
      const actionResponse = await minutasPronostico.getLinkDescarga(fecha)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  deleteMinutasPronostico ({ commit }) {
    return commit('MINUTAS_PRONOSTICO_DELETED', undefined)
  }
}
